<template>
        <div id='rules'>
              <NavTop title='规则中心'/>
              <div class='content'>
                <div class="topcon" v-html="aboutus.content">
                </div>
                <div class="docgroup">
                  <van-cell title="服务协议" is-link @click="goDoc(2)"/>
                  <van-cell title="隐私政策" is-link @click="goDoc(3)"/>
                  <van-cell title="推广规范" is-link @click="goDoc(4)"/>
                  <van-cell title="退货退款协议" is-link @click="goDoc(5)"/>
                  <van-cell title="货品寄存协议" is-link @click="goDoc(6)"/>
                </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import {Cell, CellGroup } from 'vant'

export default {
  data(){
      return{
         aboutus:''
      }
  },  
  name: 'rules',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        this.$post("/article/getArticle",{type:7}).then((data)=>{
            if(data.result.success){
               this.aboutus=data.result.info
            }else{
               this.$toast(data.result.info)
            }
        })
     },
     goDoc(type){
        this.$go("/article/"+type)    
     }
  },
  components:{
      NavTop,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup
  }
}
</script>
<style scoped>
#rules{background-color:#F6F6F6;min-height: 100vh;}
.content{display: flex;flex-flow: column nowrap;}
.topcon{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;}
.barcode{margin-top: 0.2rem;}
.barcode img {width:80%;}
.barwords{font-size: 0.3rem;color:#ccc;padding: 0.1rem;}
.contact{font-size: 0.45rem;color:#333;padding: 0.1rem;}
.docgroup{margin-top:0.3rem;}
</style>


